import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { components, paths } from "@/lib/ApiSchema.d.ts";
import type { paths as allauthPaths } from "@/lib/AllauthApiSchema.d.ts";

const fetchClient = createFetchClient<paths & allauthPaths>();
const $api = createClient(fetchClient);

export { fetchClient };
export default $api;

export type ErrorSchema =
  | components["schemas"]["ErrorSchema"]
  | {
      // Pydantic validation errors
      detail: Array<{
        ctx: { reason: string };
        loc: string[];
        msg: string;
        type: string;
      }>;
    };
